import React, { CSSProperties, FC } from 'react';
import styles from './PropertyCarousel.module.scss';

type PropertyCarouselCanvasPlaceholderProps = {
	width: number;
	height: number;
};

export const PropertyCarouselCanvasPlaceholder: FC<PropertyCarouselCanvasPlaceholderProps> = ({ width, height }) => {
	return (
		<canvas
			className={styles.propertyCarouselCanvasPlaceholder}
			width={width}
			height={height}
			style={
				{
					'--aspect-ratio': `${width}/${height}`,
				} as CSSProperties
			}
		/>
	);
};
